"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("../Button"));
var Container = (0, material_1.styled)('div', { name: 'PrismImpBanner-container' })({
    alignItems: 'center',
    background: '#000000',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: '20px 32px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
});
var Message = (0, material_1.styled)('div', { name: 'PrismImpBanner-message' })({
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 500,
});
var Name = (0, material_1.styled)('span', { name: 'PrismImpBanner-name' })({
    fontWeight: 600,
});
var ImpersonationBanner = function (_a) {
    var _b;
    var identity = _a.identity, onStopImpersonation = _a.onStopImpersonation;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Message, null,
            "Impersonating:",
            ' ',
            react_1.default.createElement(Name, null,
                identity.preferredName || identity.firstName,
                " ",
                identity.lastName),
            ' ',
            "(",
            identity.email,
            ",",
            ' ',
            ((_b = identity.customer) === null || _b === void 0 ? void 0 : _b.name) ? "".concat(identity.customer.name, ", ") : '',
            ' ',
            identity.identityUuid,
            ")"),
        react_1.default.createElement(Button_1.default, { onClick: onStopImpersonation, color: "secondary", variant: "contained" }, "Stop Impersonating")));
};
exports.default = ImpersonationBanner;
//# sourceMappingURL=index.js.map